import type { NlpFilters } from '@massilia/queries'

import type {
  LuggageFilterValue,
  StopsFilterValue,
} from '@/lib/schemas/flight-results-search.schema'

import type { SegmentTimeFilter } from './time-filter'

export interface FlightUrlFilterParams {
  filterAirlines?: string
  filterDurationMax?: number
  filterDurationMin?: number
  filterLuggage?: LuggageFilterValue
  filterPriceMax?: number
  filterPriceMin?: number
  filterStops?: StopsFilterValue
  filterTimeRanges?: string
}

export function nlpFiltersToUrlParams(filters: NlpFilters): FlightUrlFilterParams {
  const out: FlightUrlFilterParams = {}
  if (filters.stops && filters.stops !== 'all') out.filterStops = filters.stops
  if (filters.luggage) out.filterLuggage = filters.luggage
  if (typeof filters.maxPrice === 'number' && Number.isFinite(filters.maxPrice)) {
    out.filterPriceMax = filters.maxPrice
  }
  if (
    typeof filters.maxDurationMinutes === 'number' &&
    Number.isFinite(filters.maxDurationMinutes)
  ) {
    out.filterDurationMax = filters.maxDurationMinutes
  }
  if (filters.excludedAirlines && filters.excludedAirlines.length > 0) {
    out.filterAirlines = filters.excludedAirlines.join(',')
  }
  if (filters.timeFilters && filters.timeFilters.length > 0) {
    out.filterTimeRanges = JSON.stringify(filters.timeFilters)
  }
  return out
}

export function urlParamsToNlpFilters(params: FlightUrlFilterParams): NlpFilters {
  const out: NlpFilters = {}
  if (params.filterStops && params.filterStops !== 'all') out.stops = params.filterStops
  if (params.filterLuggage) out.luggage = params.filterLuggage
  if (typeof params.filterPriceMax === 'number') out.maxPrice = params.filterPriceMax
  if (typeof params.filterDurationMax === 'number') {
    out.maxDurationMinutes = params.filterDurationMax
  }
  if (params.filterAirlines) {
    const codes = params.filterAirlines.split(',').filter(Boolean)
    if (codes.length > 0) out.excludedAirlines = codes
  }
  if (params.filterTimeRanges) {
    try {
      const parsed = JSON.parse(params.filterTimeRanges) as SegmentTimeFilter[]
      if (Array.isArray(parsed) && parsed.length > 0) out.timeFilters = parsed
    } catch {
      // Ignore malformed URL JSON — the user gets no filter rather than a crash.
    }
  }
  return out
}
